module.exports = __webpack_public_path__ + "static/media/helpdesk1.566aca36.jpg";